import I18n from 'I18n';
// @ts-expect-error Untyped module
import { TEAM } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';
import { TextCell } from './TextCells';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamCell = ({
  crmObject,
  propertyName
}) => {
  const teamPerms = getPropertyValue(crmObject, propertyName);
  // TODO: remove 'null' check when BE returns null instead of 'null'
  if (!teamPerms || teamPerms === 'null') {
    return /*#__PURE__*/_jsx(TextCell, {
      value: I18n.text('content-management-listing-lib.table.cells.emptyValues.team')
    });
  }
  return /*#__PURE__*/_jsx(ResolvedCell, {
    id: teamPerms,
    objectType: TEAM
  });
};
export default TeamCell;